/**
 * -----------------------------------------------------------------------------
 * It renders a man uploading a file
 * TODO: remove the inline colors later.
 */
export function UploadFileTypellustrationSVG() {
  return (
    <svg fill="none" height="200" viewBox="0 0 185 200" width="185">
      <path
        d="M93.85 171.175c41.504 0 75.15-1.964 75.15-4.387 0-2.424-33.646-4.388-75.15-4.388-41.504 0-75.15 1.964-75.15 4.388 0 2.423 33.646 4.387 75.15 4.387Z"
        fill="#E5E5E5"
      />
      <path
        d="m47.095 88.378-.244-.298a25.88 25.88 0 0 1 3.178-2.217l.198.337a25.504 25.504 0 0 0-3.132 2.178Zm-7.961 11.077-.36-.135a26.63 26.63 0 0 1 6.073-9.438l.275.275a26.287 26.287 0 0 0-5.988 9.298Z"
        fill="#16A34A"
      />
      <path
        d="M114.226 116.537A20.653 20.653 0 0 0 85.85 97.564a24.953 24.953 0 0 0-46.782 5.523 21.475 21.475 0 0 0-20.11 22.13 21.47 21.47 0 0 0 21.51 20.773h68.339a15.23 15.23 0 0 0 14.993-12.467 15.225 15.225 0 0 0-9.567-16.99l-.007.004Z"
        fill="#16A34A"
      />
      <path
        d="M98.854 109.599h-54.69a1.686 1.686 0 0 1-1.678-1.682 1.682 1.682 0 0 1 1.679-1.679h54.689a1.68 1.68 0 0 1 1.186 2.866 1.688 1.688 0 0 1-1.186.495Z"
        fill="#0C270F"
      />
      <path
        d="M90.606 132.311H52.413a5.644 5.644 0 1 1 0-11.286h38.193a5.64 5.64 0 0 1 5.643 5.643 5.645 5.645 0 0 1-5.643 5.643Zm-38.193-10.899a5.255 5.255 0 0 0-5.256 5.256 5.257 5.257 0 0 0 5.256 5.256h38.193a5.258 5.258 0 0 0 5.256-5.256 5.254 5.254 0 0 0-5.256-5.256H52.413Z"
        fill="#fff"
      />
      <path
        d="M61.335 130.955H52.42a4.305 4.305 0 0 1-4.306-4.287 4.302 4.302 0 0 1 4.287-4.29h8.915a4.301 4.301 0 0 1 4.287 4.29 4.303 4.303 0 0 1-4.268 4.287Z"
        fill="#fff"
      />
      <path
        d="m100.416 77.018-7.252 30.899H49.901l12.1-51.57 29.958 7.028 8.457 13.643Z"
        fill="#16A34A"
      />
      <path
        d="m100.416 77.018-7.252 30.899H49.901l12.1-51.57 29.958 7.028 8.457 13.643Z"
        fill="#fff"
      />
      <path
        d="m94.772 82.762-32.86-7.713a.877.877 0 0 1-.654-1.054.88.88 0 0 1 1.054-.66l32.864 7.702a.884.884 0 0 1 .263 1.61.887.887 0 0 1-.667.115Zm-1.255 5.348-32.86-7.712a.879.879 0 1 1 .403-1.713l32.86 7.712a.88.88 0 0 1-.403 1.714Zm-1.257 5.33L59.4 85.73a.884.884 0 0 1-.654-1.057.888.888 0 0 1 1.058-.655l32.86 7.709a.88.88 0 1 1-.403 1.713Zm-1.251 5.364-32.864-7.69a.888.888 0 0 1-.655-1.058.883.883 0 0 1 1.058-.655l32.86 7.71a.888.888 0 0 1 .66 1.058.88.88 0 0 1-1.059.635Zm-14.322 2.283-19.794-4.65a.88.88 0 0 1-.64-1.059.877.877 0 0 1 1.055-.655l19.798 4.651a.88.88 0 1 1-.419 1.713Zm23.729-24.069-11.05-2.593 2.593-11.05 8.457 13.643Z"
        fill="#16A34A"
      />
      <path
        d="m107.838 106.358-9.186 60.43h1.814l1.213-7.996h23.403l-1.213 7.996h1.814l9.186-60.43h-27.031Zm17.488 50.833h-23.403l1.307-8.574h23.402l-1.306 8.574Zm1.551-10.174H103.47l1.306-8.574h23.403l-1.302 8.574Zm1.55-10.175h-23.411l1.307-8.573h23.402l-1.298 8.573Zm1.55-10.174h-23.41l1.302-8.577h23.403l-1.295 8.577Zm-21.864-10.178 1.303-8.573h23.402l-1.302 8.573h-23.403Z"
        fill="#0C270F"
      />
      <path
        d="M138.648 106.358h-27.031l9.186 60.43h1.814l-1.217-7.996h23.403l1.217 7.996h1.814l-9.186-60.43Zm-24.981 1.551h23.403l1.302 8.573H114.97l-1.303-8.573Zm1.551 10.174h23.399l1.302 8.577h-23.403l-1.298-8.577Zm1.55 10.178h23.403l1.294 8.589h-23.402l-1.295-8.589Zm1.551 10.174h23.402l1.303 8.574h-23.415l-1.29-8.574Zm2.848 18.748-1.302-8.573h23.403l1.302 8.573h-23.403Z"
        fill="#0C270F"
      />
      <path
        d="M138.648 106.358h-27.031l9.186 60.43h1.814l-1.217-7.996h23.403l1.217 7.996h1.814l-9.186-60.43Zm-24.981 1.551h23.403l1.302 8.573H114.97l-1.303-8.573Zm1.551 10.174h23.399l1.302 8.577h-23.403l-1.298-8.577Zm1.55 10.178h23.403l1.294 8.589h-23.402l-1.295-8.589Zm1.551 10.174h23.402l1.303 8.574h-23.415l-1.29-8.574Zm2.848 18.748-1.302-8.573h23.403l1.302 8.573h-23.403Z"
        fill="#fff"
        opacity={0.4}
      />
      <path
        d="M127.067 47.542c.775.596 1.457 1.193 2.162 1.813a50.09 50.09 0 0 1 2.047 1.911 43.065 43.065 0 0 1 3.783 4.233l.434.585.217.29c.123.172.233.352.329.54.312.626.494 1.309.535 2.007a10.444 10.444 0 0 1-.329 3.198 21.597 21.597 0 0 1-2.148 5.349l-1.98-.807c.396-1.672.677-3.37.841-5.08a8.456 8.456 0 0 0-.07-2.214 1.53 1.53 0 0 0-.229-.585c-.019-.02-.027-.02-.038-.031l-.21-.237-.418-.477a60.965 60.965 0 0 0-3.682-3.658 146.034 146.034 0 0 0-3.938-3.465l2.694-3.372Z"
        fill="#FECACA"
      />
      <path
        d="m132.904 65.863-2.229 1.55 2.713 1.644s1.399-1.338.798-2.578l-1.282-.616Z"
        fill="#FECACA"
      />
      <path
        d="m129.566 69.96 2.055 1.15 1.783-2.073-2.729-1.64-1.109 2.563Z"
        fill="#FECACA"
      />
      <path
        d="M111.892 39.44c.062.253-.019.49-.182.532-.163.043-.349-.128-.415-.388-.065-.26.02-.488.183-.53.162-.043.348.123.414.387Zm.004.485a9.237 9.237 0 0 1-.647 2.45 1.502 1.502 0 0 0 1.256-.081l-.609-2.369Zm.527-2.1a.152.152 0 0 1-.093 0 1.213 1.213 0 0 0-1.097.073.15.15 0 0 1-.222-.148.153.153 0 0 1 .048-.096 1.505 1.505 0 0 1 1.384-.112.153.153 0 0 1 .094.15.147.147 0 0 1-.035.087.149.149 0 0 1-.079.05v-.004Z"
        fill="#0C270F"
      />
      <path
        d="M119.838 40.146c.36 2.365.868 5.989 2.946 6.903 0 0 .201 2.458-3.903 3.934-4.512 1.624-2.962-1.46-2.962-1.46 2.252-1.478 1.531-3.28.485-4.842l3.434-4.535Z"
        fill="#FECACA"
      />
      <path
        d="M123.171 46.542c0-.74-.756-2.024-1.519-1.938-.841.096-4.05 1.279-5.221 2.36-1.171 1.081-.341 2.977-.341 2.977l7.081-3.4Z"
        fill="#0C270F"
      />
      <path
        d="M147.919 136.153c-.202.209-.43.387-.609.36-.077 0-.178-.054-.228-.225a.304.304 0 0 1 .034-.259c.218-.369 1.163-.559 1.19-.566a.065.065 0 0 1 .039.003.067.067 0 0 1 .031.024c.007.011.01.024.01.037a.065.065 0 0 1-.01.036 3.678 3.678 0 0 1-.457.59Zm-.636-.121a.34.34 0 0 0-.054.066.182.182 0 0 0-.019.151c.038.121.096.128.116.132.197.023.604-.387.849-.748a2.19 2.19 0 0 0-.892.399Z"
        fill="#16A34A"
      />
      <path
        d="M148.369 135.575a.067.067 0 0 1-.028.019c-.321.101-1.162.074-1.352-.19a.225.225 0 0 1 .023-.275.365.365 0 0 1 .263-.147c.423-.05 1.062.473 1.09.496a.066.066 0 0 1 .023.062.08.08 0 0 1-.019.035Zm-1.229-.388-.02.024c-.054.069-.031.1-.019.116.109.155.702.225 1.066.167a1.6 1.6 0 0 0-.876-.388.213.213 0 0 0-.151.081Zm-22.67 9.066c-.365 0-.717-.05-.838-.213a.265.265 0 0 1 0-.295.338.338 0 0 1 .214-.158c.473-.128 1.469.437 1.511.465a.055.055 0 0 1 .026.028.055.055 0 0 1 .005.038.063.063 0 0 1-.017.038.075.075 0 0 1-.037.02 5.11 5.11 0 0 1-.864.077Zm-.45-.55a.417.417 0 0 0-.132 0 .196.196 0 0 0-.076.032.201.201 0 0 0-.055.061c-.047.085-.031.124 0 .151.131.182.848.186 1.379.112a3.053 3.053 0 0 0-1.112-.356h-.004Z"
        fill="#16A34A"
      />
      <path
        d="M125.334 144.176a.042.042 0 0 1-.027 0c-.345-.152-1.023-.776-.973-1.089 0-.078.066-.171.252-.19a.495.495 0 0 1 .387.116c.261.309.416.693.442 1.097a.06.06 0 0 1-.005.035.063.063 0 0 1-.022.027.077.077 0 0 1-.027.008.084.084 0 0 1-.027-.004Zm-.694-1.163h-.042c-.121 0-.128.058-.132.074-.031.193.434.678.775.887a1.553 1.553 0 0 0-.388-.876.356.356 0 0 0-.213-.077v-.008Z"
        fill="#16A34A"
      />
      <path
        d="M128.466 144.11h-2.849l-.283-6.597h2.849l.283 6.597Zm22.817-9.659-2.636.957-3.348-5.907 2.635-.957 3.349 5.907Z"
        fill="#FECACA"
      />
      <path
        d="m148.233 135.149 2.225-2.303a.252.252 0 0 1 .306-.038l2.209 1.356a.426.426 0 0 1 .194.308.414.414 0 0 1-.12.343c-.775.776-1.213 1.136-2.19 2.148-.605.62-2.396 2.713-3.225 3.589-.829.876-1.791.147-1.527-.279 1.182-1.911 1.895-3.729 1.938-4.671a.685.685 0 0 1 .19-.453Zm-22.601 8.631h3.101a.247.247 0 0 1 .244.194l.562 2.531a.42.42 0 0 1-.081.353.41.41 0 0 1-.329.151c-1.121 0-2.741-.081-4.152-.081-1.647 0-2.368.089-4.302.089-1.163 0-1.492-1.182-1.004-1.291 2.229-.488 3.341-.539 5.268-1.725.206-.136.446-.213.693-.221Z"
        fill="#0C270F"
      />
      <path
        d="M117.9 53.197a67.627 67.627 0 0 1-1.384 3.185 71.17 71.17 0 0 1-1.519 3.101 47.308 47.308 0 0 1-3.663 6.05c-.36.489-.748.973-1.163 1.454-.213.244-.43.469-.686.72-.296.28-.619.53-.965.745-.569.348-1.168.645-1.79.888a19.2 19.2 0 0 1-1.733.6 35.578 35.578 0 0 1-6.88 1.28l-.434-2.094c2.074-.748 4.182-1.527 6.124-2.395.481-.225.954-.453 1.395-.69.409-.212.798-.46 1.163-.74a2.24 2.24 0 0 0 .345-.322c.136-.159.299-.345.446-.535.298-.387.593-.798.876-1.236.577-.86 1.112-1.795 1.628-2.744a91.202 91.202 0 0 0 1.5-2.907c.965-1.965 1.899-4 2.759-5.988l3.981 1.627Z"
        fill="#FECACA"
      />
      <path
        d="M124.4 45.84c4.085-.318 7.752 5.74 7.752 5.74l-2.934 4.768a21.17 21.17 0 0 1-5.814-3.462c-2.779-2.414-1.795-6.825.996-7.046Z"
        fill="#16A34A"
      />
      <path
        d="m124.144 50.945 4.298 5.786-.193.237s-1.481-1.163-3.194-2.845l-.911-3.178Z"
        fill="#0C270F"
        opacity={0.3}
      />
      <path
        d="M113.071 50.355c-.229 1.997 3.1 10.826 3.875 21.299l15.159-1.493c-.108-2.007-1.217-10.465-3.225-20.011-.554-2.636-2.596-4.651-5.236-4.136h-.074c-2.12.414-4.213.951-6.271 1.609a27.797 27.797 0 0 0-3.395 1.5 1.571 1.571 0 0 0-.833 1.233Z"
        fill="#16A34A"
      />
      <path
        d="M114.605 57.689c.256 1.066.524 2.22.776 3.45 2.306-.547 1.86-5.66 1.907-5.726l-2.683 2.276Z"
        fill="#0C270F"
        opacity={0.3}
      />
      <path
        d="M118.009 51.344c1.162 3.988-3.14 9.302-3.14 9.302l-4.333-2.79s-.031-3.656 1.353-6.508c1.755-3.613 5.29-2.85 6.12-.004Z"
        fill="#16A34A"
      />
      <path
        d="m97.726 68.747-1.74-.237.027 3.636s2.345.24 3.647-1.376l-.256-.682a2.097 2.097 0 0 0-1.678-1.341Z"
        fill="#FECACA"
      />
      <path
        d="m93.013 69.351 1.112 2.962 1.903-.167-.027-3.636-2.988.841Z"
        fill="#FECACA"
      />
      <path
        d="m125.334 137.517.159 3.705h2.849l-.159-3.705h-2.849Zm22.6-8.973-2.635.957 1.852 3.272 2.512-1.186-1.729-3.043Z"
        fill="#0C270F"
        opacity={0.2}
      />
      <path
        d="M120.113 36.767c.601 3.127 1.113 4.926-.039 6.906-1.728 2.977-5.891 2.54-7.41-.345-1.372-2.6-2.124-7.275.566-9.27a4.337 4.337 0 0 1 4.199-.571 4.347 4.347 0 0 1 2.684 3.28Z"
        fill="#FECACA"
      />
      <path
        d="M114.846 38.856c-1.907.953-1.938-2.093-1.787-2.74-.717.69-1.686 1.383-3.446.623-2.162-.934-1.55-3.375 0-3.344 0 0-1.162-2.21 1.38-2.442a8.434 8.434 0 0 1 3.078.473s.941-2.47 3.236-1.272c1.213.632 2.182 2.5 2.182 2.5s4.942.733 2.26 3.314c.608 1.326.287 5.64-1.283 7.484-.686.807-6.558.57-5.62-4.596Z"
        fill="#0C270F"
      />
      <path
        d="M118.632 33.914s.896-1.236.969-4.09c2.09 2.272-.969 4.09-.969 4.09Z"
        fill="#0C270F"
      />
      <path
        d="M115.772 38.681a3.59 3.59 0 0 1-.605 2.233c-.581.864-1.372.492-1.627-.419-.233-.818-.21-2.256.577-2.798.787-.543 1.574.03 1.655.984Z"
        fill="#FECACA"
      />
      <path
        d="M122.33 71.126s5.349 21.318 7.915 29.275c2.806 8.698 14.984 31.5 14.984 31.5l4.779-2.082s-9.217-20.759-11.186-29.457c-2.136-9.426-6.709-30.208-6.709-30.208l-9.783.972Z"
        fill="#737373"
      />
      <path
        d="M143.814 130.327c-.019 0 1.551 2.244 1.551 2.244l5.368-2.372-1.086-2.221-5.833 2.349Z"
        fill="#16A34A"
      />
      <path
        d="M125.125 78.642c3.79.36 4.759 14.267 5.015 21.445-1.57-4.938-4.093-14.484-5.845-21.263.248-.153.541-.217.83-.182Z"
        fill="#0C270F"
        opacity={0.3}
      />
      <path
        d="M116.954 71.654s.616 21.906 1.775 30.518c1.206 8.958 5.663 37.597 5.663 37.597h4.826s-1.117-28.922-1.772-37.771c-.713-9.647-.527-31.333-.527-31.333l-9.965.989Z"
        fill="#737373"
      />
      <path
        d="M123.431 137.517c-.02 0 .387 2.918.387 2.918l5.865-.201.054-2.713-6.306-.004Z"
        fill="#16A34A"
      />
    </svg>
  );
}
